import * as React from "react";
import CustomBarChart from "./DataViz/customBarChart.Component";
import CustomScrollbars from "./CustomScrollbar";
import ModalVideo from "react-modal-video";
import "./resultTiles.css";
import Loader from "react-loader";
import "font-awesome/css/font-awesome.min.css";

import {currentDesignation, currentUser} from '../common/services';

// interface IProps {
//   results: any;
// }

const vimeoVar = "understand_perceptions";
class PerceptionsTile extends React.Component {
  state = {
    videoWatched: false,
    isVidOpen: false,
    vidLink: "",
    vidVar: "",
    scrolltop: 0,
    vimeoList: [],
    vimeoLoaded: false,
  };
  constructor(props) {
    super(props);
    this.perceptionLevelToPercent = this.perceptionLevelToPercent.bind(this);
    this.generatePerceptionComment = this.generatePerceptionComment.bind(this);
    this.generatePerceptionContent = this.generatePerceptionContent.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.watchCategoryVideo = this.watchCategoryVideo.bind(this);
    this.skipVideo = this.skipVideo.bind(this);
    this.scrollContent = this.scrollContent.bind(this);
    this.perceptionsContainer = React.createRef();
  }

  async componentDidMount() {
    // fetch right vimeo video
    // fetch right vimeo video
    const {
      services: { adminAPI },
    } = this.props;
    const [perceptionsRes, vimeoRes] = await Promise.all([adminAPI.getPerceptions(), adminAPI.fetchVimeoSystemVar(vimeoVar)]);
    // console.log(JSON.stringify(perceptionsRes, null, 2));
    if (perceptionsRes.ok) {
      // const perceptionsList = perceptionsRes.data.perceptions;
      // const vimeoList = [];
      // perceptionsList.map((p) => {
      //   vimeoList.push({
      //     name: p.name,
      //     videoID: p.GeneralVideo !== null ? p.GeneralVideo.id : "",
      //   });
      // });
      // console.log(vimeoList);
      this.setState({ vidVar: vimeoRes.data.value });
    }
  }

  getPerceptionVideo = (name) => {
    const { vimeoList } = this.state;
    const vidObj = vimeoList.filter((p) => p.name === name);
    return vidObj[0].videoID;
  };

  perceptionLevelToPercent(level) {
    const max = 8;
    // let levelint = 8;
    if (level === "Extremely Positive") {
      let levelint = 8;
      return (levelint / max) * 100.0;
    } else if (level === "Positive") {
      let levelint = 7;
      return (levelint / max) * 100.0;
    } else if (level === "Neutral / Positive") {
      let levelint = 6;
      return (levelint / max) * 100.0;
    } else if (level === "Neutral") {
      let levelint = 5;
      return (levelint / max) * 100.0;
    } else if (level === "Negative") {
      let levelint = 4;
      return (levelint / max) * 100.0;
    } else if (level === "Neutral / Negative") {
      let levelint = 3;
      return (levelint / max) * 100.0;
    } else if (level === "Negative / Extremely Negative") {
      let levelint = 2;
      return (levelint / max) * 100.0;
    } else if (level === "Extremely Negative") {
      let levelint = 1;
      return (levelint / max) * 100.0;
    } else {
      return 10;
    }
  } // end level to %

  //  Orange: #f56f3f
  // Red: #e7233d
  // Green: #18ee97
  // Yellow: #feb743
  // Purple: #8e0666

  generatePerceptionComment(percent) {
    if (percent > 0 && percent <= 20) {
      return ["Extremely Urgent Attention Needed", "#e7233d"];
    } else if (percent > 20 && percent <= 40) {
      return ["Urgent Attention Needed", "#8e0666"];
    } else if (percent > 40 && percent <= 60) {
      return ["Moderate Attention Needed", "#f56f3f"];
    } else if (percent > 60 && percent <= 80) {
      return ["Low Attention Needed", "#feb743"];
    } else {
      return ["No Attention Needed", "#18ee97"];
    }
  } // end generateperception comment

  currentUserKeys = () => {
    //   0 -> video model
    // 1 - > perception name
      if(this.props.designation === 'students' ){
          return ['StudentVideo', 'name_students'];
      }
      if(this.props.designation === 'parents' ){
          return ['ParentVideo', 'name_parents'];
      }
      if(this.props.designation === 'teachers' ){
          return ['TeacherVideo', 'name_teachers'];
      }
  }

  openModal(vidId, evt) {
    if(vidId === 'NO_VID') { console.log('No video'); return;}
    this.setState({ isVidOpen: true, vidLink: vidId });
  }

  closeModal() {
    this.setState({ isVidOpen: false, videoWatched: true });
  }

  skipVideo() {
    this.setState({ videoWatched: true });
  }

  scrollContent() {
    if (this.state.scrolltop >= this.refs.scrollbars.getScrollHeight()) {
      this.setState({ scrolltop: -200 });
      this.refs.scrollbars.scrollTop(this.state.scrolltop);
    } else {
      this.setState((prevState) => ({
        scrolltop: prevState.scrolltop + 300,
      }));
      this.refs.scrollbars.scrollTop(this.state.scrolltop);
    }
  }

  watchCategoryVideo() {
    if (this.props.results) {
      // console.log(JSON.stringify(this.props.results, null, 2));
      return (
        <div className="perceptions-guide">
          <h1 className="current-groupname">UNderstand Perceptions</h1>
          <button
            className="blue-button about-perceptions"
            // onClick={this.openModal.bind(this, this.state.vidVar)}
            onClick={this.skipVideo}
            value={this.state.vidVar}
          >
            View Results
          </button>

          {/* temp comment below */}
          {/* <p className="btn-skip-vid" onClick={this.skipVideo}>
            Skip Video
          </p> */}
        </div>
      );
    } else {
      return <Loader />;
    }
  }

  generatePerceptionContent() {
    if (this.props.results) {
      return (
        <div className="perceptions-tile-container">
          <div className="scroll-sec" ref={this.perceptionsContainer}>
            <p>Scroll down for more</p>
            <button
              className="red-button response-nav-btn"
              onClick={this.scrollContent}
            >
              <i
                style={{ color: "#ff0033" }}
                className="fa fa-arrow-down scroll-icon"
                aria-hidden="true"
              />
            </button>
          </div>
          <CustomScrollbars
            ref="scrollbars" // for clicking to scroll
            className="perceptions-disp-area"
            style={{ height: "550px", oveflowY: "scroll" }}
          >
            {/* perceptions + descriptions */}
            {this.props.results.map((perceptionItem) => {
              return (
                <div className="perceptions-holder" key={perceptionItem.definition_data.id}>
                  <CustomBarChart
                    strokeSize={20}
                    value={this.perceptionLevelToPercent(
                      perceptionItem.level_data.Name
                    )}
                    color={
                      this.generatePerceptionComment(
                        this.perceptionLevelToPercent(
                            perceptionItem.level_data.Name
                        )
                      )[1]
                    }
                  />
                  <div className="perception-description">
                    <div className="left">
                      <h2 className="perception-action">
                        {
                          this.generatePerceptionComment(
                            this.perceptionLevelToPercent(
                                perceptionItem.level_data.Name
                            )
                          )[0]
                        }
                      </h2>
                      <p className="perception-category">
                        {perceptionItem.definition_data.data[this.currentUserKeys()[1]]}
                      </p>
                    </div>
                    <div className="right">
                      <button
                        className="blue-button more-button"
                        value={perceptionItem.level_data.Name}
                        onClick={this.openModal.bind(
                          this,
                          perceptionItem.definition_data[this.currentUserKeys()[0]] != null ?  perceptionItem.definition_data[this.currentUserKeys()[0]].VideoData.id : 'NO_VID'
                        )}
                      >
                        Learn More
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
            {/*END PERCEPTION */}
          </CustomScrollbars>
        </div>
      );
    } else {
      return <Loader />;
    }
  }

  render() {
    return (
      <div style={{ width: "100%", height: "100%" }}>
        <ModalVideo
          channel="vimeo"
          isOpen={this.state.isVidOpen}
          onClose={this.closeModal}
          videoId={this.state.vidLink}
        />
        <h2 className="perceptions-tile-title">Perceptions</h2>

        {this.state.videoWatched || this.props.videoWatched
          ? this.generatePerceptionContent()
          : this.watchCategoryVideo()}
      </div>
    );
  }
}

export default PerceptionsTile;



// WEBPACK FOOTER //
// ./src/common/perceptionsTileNew.Component.js